"use client";

import { Noticia } from "@/lib/api/datosGenerales/types/noticias";
import NoticiaShell from "./NoticiaShell";

interface Props {
  noticia: Noticia;
  locale: "es" | "en";
  tiempoLectura: number;
  noticiasRelacionadas: Noticia[];
  basePath?: string;
}

export default function NoticiaPlantillaTexto(props: Props) {
  return <NoticiaShell {...props} />;
}
